<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const addLogo = () => {
  props.block.data.logos = [...(props.block.data.logos ?? []), { image: '', alt: '', link_url: '' }]
}
const removeLogo = (i: number) => {
  props.block.data.logos?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      :placeholder="t('site.f.logo_strip.e_g_trusted_by', 'e.g. Trusted by')"
      class="w-full"
    />
  </UFormField>
  <SiteEditorArrayItemCard
    v-for="(logo, i) in block.data.logos ?? []"
    :key="i"
    :label="`${t('site.f.logo_strip.item_label', 'Logo')} ${i + 1}`"
    @remove="removeLogo(i)"
  >
    <SiteEditorImagePicker
      :label="t('site.f.common.image_label', 'Image')"
      variant="logo"
      :model-value="logo.image"
      @update:model-value="logo.image = $event"
    />
    <UInput
      :model-value="logo.alt ?? ''"
      :placeholder="t('site.f.common.alt_text_label', 'Alt text')"
      class="w-full"
      @update:model-value="logo.alt = String($event)"
    />
    <UInput
      :model-value="logo.link_url ?? ''"
      :placeholder="t('site.f.common.link_url_optional_label', 'Link URL (optional)')"
      class="w-full"
      @update:model-value="logo.link_url = String($event)"
    />
  </SiteEditorArrayItemCard>
  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addLogo"
  >
    {{ t('site.f.logo_strip.add_item', 'Add logo') }}
  </UButton>
</template>
